/* eslint-disable react/prop-types */
import React from "react";
import { Box, makeStyles } from "@material-ui/core";
import { primaryColor } from "resources/constants";
import ScaleLoader from "react-spinners/ScaleLoader";

const useStyles = makeStyles(() => ({
  spinnerContainer: {
    textAlign: "center",
  },
}));

const LoadingSpinner = () => {
  const classes = useStyles();
  return (
    <Box className={classes.spinnerContainer} data-testid="spinner-box">
      <ScaleLoader
        size={150}
        color={primaryColor}
        loading
        data-testid="spinner"
      />
    </Box>
  );
};

export default LoadingSpinner;
